import { render, staticRenderFns } from "./SithMesSapHandleRecordList.vue?vue&type=template&id=41a8dd47&"
import script from "./SithMesSapHandleRecordList.vue?vue&type=script&lang=js&"
export * from "./SithMesSapHandleRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports